if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      // console.log('MutationList', MutationList)
      for (let item of MutationList) {
        if (
          item.target.classList.contains("quick-buy-modal") ||
          item.target.classList.contains("quick-buy-modal__content")
        ) {
          BSS_B2B.observer.productSubject.notifyObserver(
            "ProductMutate",
            "ProductPriceMutate"
          );
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);
}
